import { useEffect, useState } from "react";
import { authFetch } from "../auth";

export default function AuthImage({ fileId, team = false, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    let cancelled = false;
    authFetch(`/${team ? "team" : "portal"}/files/${fileId}/download`)
      .then((r) => (r.ok ? r.blob() : null))
      .then((b) => {
        if (b && !cancelled) {
          url = URL.createObjectURL(b);
          setSrc(url);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileId, team]);
  if (!src) return <div className={`animate-pulse bg-[#0E3B33]/5 ${className}`} />;
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}
